import React from 'react';
import {Link} from 'react-router-dom';
import './header.css';
import logo from './folksy-logo.png';

const isUser = user => (
  user !== null
)

const isSeller = user => (
  user !== null && user.isSeller
)

export default ({folksyRootEndpoint, folksyDashboardEndpoint, user}) => {
  return (
    <div className="Header">
      <div className="Header__wrapped">
        <a href={folksyRootEndpoint} className="Header__folksy-home-link">
          <img src={logo} className="Header__logo" alt="Folksy logo"/>
        </a>
        {isUser(user) &&
          <a href={folksyDashboardEndpoint} className="Header__folksy-dashboard-link">
            Your dashboard
          </a>
        }
        {isSeller(user) &&
          <Link to="/stats" className="Header__stats-link">Stats</Link>
        }
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/header.js